const NoPage = () => {
  return <div>NO PAGE</div>;
};

export default NoPage;
